import { createSagaAction } from 'saga-toolkit';

const name = "transactions";

export const actions = {
	REVERSE: `${name}/transactionReverse`,
}

export const transactionReverse = createSagaAction(actions.REVERSE);